import { getRequest } from '../../services/httpService';



export interface CollectionDetailsResponse {
    sample_number: string | null;
    collection_date: string | null;
    collection_time: string | null;
    receiving_date: string | null;
    receiving_time: string | null;
    semen_collection_method: string | null;
    surgical_extraction_type: string | null;
    abstinence: string | null;
    analysis_time: string | null;
    sample_collection: string | null;
    difficulty_in_collection: boolean | null;
    volume: string | null;
    wbc: string | null;
    interpretation: string | null;
    sperm_evaluated_count: string | null;
    service_name: string | null;
  }

export interface SemenAnalysisReportResponse {
    id: number;
    lab_test: number;
    date_of_prescription: string;
    service_code: number;
    doctor: number;
    service_name: string;
    doctor_name: string;
    sample_number: string;
    collection_date: string | null;
    collection_time: string | null;
    receiving_date: string | null;
    receiving_time: string | null;
    semen_collection_method: string | null;
    surgical_extraction_type: string | null;
    abstinence: string | null;
    analysis_time: string | null;
    sample_collection: string | null;
    difficulty_in_collection: string | null;
    difficulty_in_collection_remark: string | null;
    volume: string | null;
    color: string | null;
    appearance: string | null;
    ph: string | null;
    liquefaction_time_in_min: string | null;
    viscosity: string | null;
    odour: string | null;
    sperm_concentration: string | null;
    total_sperm_count: string | null;
    rapid_progressive: string | null;
    slow_progressive: string | null;
    non_progressive: string | null;
    head_defects: string | null;
    small: string | null;
    large: string | null;
    tapered: string | null;
    round: string | null;
    amorphous: string | null;
    vacuolated: string | null;
    pyriform: string | null;
    neck_midpiece_defects: string | null;
    bent: string | null;
    thin: string | null;
    thick: string | null;
    asymmetric_insertion: string | null;
    vacuoles: string | null;
    tail_defects: string | null;
    short: string | null;
    coiled: string | null;
    double: string | null;
    cytoplasmic_droplet: string | null;
    head_to_head: string | null;
    tail_to_tail: string | null;
    head_to_tail: string | null;
    sperm_to_other: string | null;
    normal: string | null;
    abnormal: string | null;
    viability: string | null;
    pus_cells: string | null;
    rbc: string | null;
    epithelial_cells: string | null;
    zinc: string | null;
    fructose: string | null;
    interpretation: string | null;
    interpretation_remark: string;
    sperm_evaluated_count: string | null;
    prognosis: string | null;
    details_remark: string | null;
    other_details_remark: string;
    remark: string | null;
    status: string;
    andrologist: string | null;
    witnessed_by: string | null;
  }
  
export function getputCollectionDetailsUrl(id: string): string {
  return `/semen-analysis/${id}/collection-details/`;
}
export function getCollectionDetailsss(analysisId: string ): Promise<CollectionDetailsResponse> {
  return getRequest(getputCollectionDetailsUrl(analysisId));
}

export function getSemenAnalysisReport(analysisId: string ): Promise<SemenAnalysisReportResponse> {
  return getRequest(`/semen-analysis/${analysisId}`);
}